import React from "react";
import { Outlet, useOutletContext } from "react-router";
import ViewComments from "./Submissions/ViewComments/ViewComments";

const ModerateContributions = () => {
  const {
    manageTiles,
    setManageTiles,
    setManageButtons,
    setsocialNavLinks,
    setRightSideLinks,
    viewCommentModal,
    setViewCommentModal,
    tenantName,
  } = useOutletContext();
  return (
    <div>
      <Outlet
        context={{
          manageTiles,
          setManageTiles,
          setManageButtons,
          setsocialNavLinks,
          setRightSideLinks,
          tenantName,
        }}
      />
      {viewCommentModal && (
        <ViewComments
          viewCommentModal={viewCommentModal}
          setViewCommentModal={setViewCommentModal}
        />
      )}
    </div>
  );
};

export default ModerateContributions;
